export const GraphSpinner = () => (
  <div className="flex items-center justify-center h-[90%] w-full absolute inset-0 z-10">
    <div className="loading loading-spinner" />
  </div>
);
